import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { date, hasMany } from '@apexdesigner/schema-tools';

export const account = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().requiredFinal().describe('Name'),

    designerSeats: z
      .number()
      .nullable()
      .optional()
      .describe(
        'Designer Seats - Number of designer seats available for this account',
      ),

    renewalDate: date()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('Renewal Date - Date the account subscription renews'),

    slackWebhookUrl: z
      .string()
      .nullable()
      .optional()
      .describe(
        'Slack Webhook Url - Optional Slack incoming webhook for account notifications',
      ),

    accountUsers: hasMany('AccountUser'),

    cases: hasMany('SupportCase'),

    comments: hasMany('SupportComment'),

    attachments: hasMany('SupportAttachment'),
  })
  .describe(
    'Tenant root for the application. Each account represents an organization\nwith its own members, billing, and data.',
  )
  .as('Account');

export { account as accountSchema };
